export default "<db:rules>\n\t<div data-id='legality' data-ignore='1'></div>\n\t<div data-id='rules' data-ignore='1'></div>\n</db:rules>\n";